(function ($) {
    $(() => {

        if ($('.sustainability-new-hero').length) {
            $('body').addClass('susactive');

            window.onbeforeunload = function () {
                window.scrollTo(0, 0);
            }

            document.getElementById('susVideo').addEventListener('ended', myVideoHandler, false);
            function myVideoHandler(e) {
                $('.sustainability-new-hero').addClass('active');
                $('.sustainability-new-hero .js-sus-card-1').addClass('active');
                setTimeout(() => {
                    $('.sustainability-new-hero .js-sus-card-2').addClass('active');
                }, 200);

                setTimeout(() => {
                    $('.sustainability-new-hero .js-sus-card-3').addClass('active');
                }, 400);

                setTimeout(() => {
                    $('.sustainability-new-hero .js-sus-card-4').addClass('active');
                    $('.sustainability-new-content-wrapper').addClass('active');
                    $('body').removeClass('susactive');
                }, 600);
            }

            $('.js-sus-arrow').on('click', function () {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#sus-srcoll-to").offset().top
                }, 1000);
            });

            $('#js-skip-video').on('click', function (e) {
                e.preventDefault();
                var video = document.getElementById("susVideo");

                if (video) {
                    video.currentTime = video.duration;
                }
            })
        }

    });
})(jQuery);